import React, { useState, useEffect, useCallback, useRef } from "react";
import $ from "jquery";
import _ from "lodash";
import { Link, NavLink } from "react-router-dom";

import TopNav from "../../commonUI/TopHeader/TopHeader";
import { getUsers, setUser } from "../../../services/adminService";
import { showSpinner, closeSpinner, modal } from "../../../js/modules/Dialogs";
import ConfirmDialog from "../../Modal/ConfirmDialog";
import { sessionExpired, adminSaveChangesConfirm, adminClientCannotPreactivate, adminClientCannotReset } from "../../../config/messages";
import { defaultAvatarBase64, serverUrl, userImagesFolder, imageFormat, defaultAvatarImage } from "../../../config/env";
import { defaultMessagesFilter } from "../../../config/constants";
import { toScreen } from "../../../js/modules/Routing";
import AuditNotes from "../../commonUI/AuditNotes";
import PropTypes from "prop-types";
import withNavigate from "../withNavigate";
import { dateProcess } from "../../../js/modules/Generic";
import moment from "moment-timezone";
import Pagination from "../../commonUI/Pagination/Pagination";
import { Box, Drawer } from "@mui/material";
import ClientEdit from "./ClientEdit";
import {
  BackArrowIcon,
  MessageIcon,
  EditIcon,
  BellIcon,
  EmailIcon,
  DiscountIcon,
  BellSlashIcon,
  ViewInStripe,
} from "../../commonUI/Icons/SvgIcon";

const Client = ({ userDetails, clientId, navigate }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [originalStatus, setOriginalStatus] = useState("");
  const ref = useRef();
  const [filter, setFilter] = useState("all");
  const auditNotesRef = useRef(null);
  const [activeTab, setActiveTab] = useState("profile");
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState(1);
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);
  const [client, setClient] = useState({
    _id: "",
    short_id: "",
    notes: [],
    accountInfo: {
      username: "",
      surname: "",
      telephone: "",
      telephone: "",
      email: "",
      avatar: false,
      terms: false,
      settings: {
        emailnotifications: false,
        holidaymode: false,
        marketingnotifications: false,
        pushnotifications: false,
      },
    },
    stripeCustomerId: "",
    userType: "",
    status: "",
    jobs: {},
  });
  const [totals, setTotals] = useState({
    total: 0,
    open: 0,
    closed: 0,
    agreed: 0,
    paid: 0,
    complete: 0,
    refund: 0,
    transferneeded: 0,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
  });
  const [sort, setSort] = useState("");
  const [search, setSearch] = useState("");

  const updateNotes = useCallback(
    (newNotes, theCallback) => {
      if (!_.isEqual(newNotes, client?.notes)) {
        setClient((prevClient) => ({
          ...prevClient,
          notes: newNotes,
        }));
        if (theCallback) {
          theCallback();
        }
      } else if (theCallback) {
        theCallback();
      }
    },
    [client?.notes]
  );

  const discardChanges = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }

      toScreen(false, navigate, "/clients");
    },
    [navigate]
  );

  const getClient = useCallback(async () => {
    showSpinner();
    try {
      const theUser = {
        accountInfo: {
          username: userDetails.accountInfo.username,
          email: userDetails.accountInfo.email,
        },
        user: clientId ?? window?.location?.pathname?.split("/")[2],
        userType: "user",
      };

      const resJson = await getUsers(theUser);

      closeSpinner();

      setOriginalStatus(resJson.theUsers["0"]?.status);
      setClient(resJson.theUsers["0"]);
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        modal(sessionExpired);
        toScreen(false, navigate, "/logout");
      } else if (error.response?.status === 400) {
        modal(error.message);
        toScreen(false, navigate, "/clients");
      } else {
        alert("Error fetching client: " + error?.message);
      }
    }
  }, [userDetails, clientId, navigate]);

  /** THIS RENDER JOBS FUNC FOR NEW DESIGN */
  const renderJobs = useCallback(
    (key) => {
      const job = client?.jobs[key];
      var originAddressShort = "";
      if (!job?.originAddress?.formattedAddress) {
        originAddressShort = "";
      } else if (job?.originAddress?.formattedAddress.length > 12) {
        originAddressShort =
          job?.originAddress?.formattedAddress.substring(0, 9) + "...";
      } else {
        originAddressShort = job?.originAddress?.formattedAddress;
      }

      var destinationAddressShort = "";
      if (!job?.destinationAddress?.formattedAddress) {
        destinationAddressShort = "";
      } else if (job?.destinationAddress?.formattedAddress.length > 12) {
        destinationAddressShort =
          job?.destinationAddress?.formattedAddress.substring(0, 9) + "...";
      } else {
        destinationAddressShort = job?.destinationAddress?.formattedAddress;
      }

      let userName =
        job._creator &&
        job._creator.accountInfo &&
        job._creator.accountInfo.username
          ? job._creator.accountInfo.username
          : "N/A";

      return (
        <tr
          // className={
          //   job.isPaused ? "c-list-entry u-color-grey-dark" : "c-list-entry"
          // }
          key={key}
        >
          <td
            className={` ${job?.status === "open" && "text-gray"} ${
              job?.status === "complete" && "text-success"
            }
            ${job?.status === "paid" && "text-success"} ${
              job?.status === "closed" && "text-yellow"
            }`}
          >
            {" "}
            {job?.status
              ? job.status.charAt(0).toUpperCase() + job.status.slice(1)
              : "N/A"}
          </td>
          <td>{_.size(job?.quotes)}</td>
          <td>
            <span className="u-before-icon-calendar2">
              &nbsp;&nbsp;
              {moment(job?.jobSpec?.dateAndTime?.standardDate)
                ?.tz("Europe/London")
                ?.format("DD MMM YYYY")}
            </span>
            <br />
            <span className="u-before-icon-clock">
              &nbsp;&nbsp;
              {moment(job?.jobSpec?.dateAndTime?.standardDate)
                ?.tz("Europe/London")
                ?.format("hh:mm ")}
            </span>
          </td>
          <td>{job?.jobSpec?.serviceType ?? "-"}</td>
          <td>
            <span className="u-before-icon-location text-capitalize">
              &nbsp;&nbsp;
              {job?.originAddress?.townCityName ||
                job?.originAddress?.regionName ||
                job?.originAddress?.formattedAddress}
              {job?.jobSpec?.serviceType != "dispose" ? "→" : null}
              {job?.destinationAddress?.townCityName ||
                job?.destinationAddress?.regionName ||
                job?.destinationAddress?.formattedAddress ||
                ""}
            </span>
          </td>
          <td>
            <span className="u-before-icon-calendar2">
              &nbsp;&nbsp;
              {moment(job?.creationDate)
                ?.tz("Europe/London")
                ?.format("DD MMM YYYY")}
            </span>
            <br />
            <span className="u-before-icon-clock">
              &nbsp;&nbsp;
              {moment(job?.creationDate)?.tz("Europe/London")?.format("hh:mm ")}
            </span>
          </td>
          <td>
            <button
              type="button"
              className="custom-btn"
              onClick={(e) => toScreen(e, navigate, "/job/" + job.short_id)}
            >
              View details
            </button>
          </td>
        </tr>
      );
    },
    [client?.jobs, navigate]
  );

  const handleInputChange = useCallback(
    (event) => {
      const target = event.target;
      const value = target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;

      if (name === "filter") {
        setFilter(value);
        // Note: filterJob will be called via useEffect when filter changes
        return;
      }

      var oldValue = false;

      const inputChangeCallback = () => {};

      if (name === "client.status") {
        oldValue = client?.status;

        setClient((prevClient) => ({
          ...prevClient,
          status: value,
        }));

        // Handle status change logic
        setTimeout(() => {
          if (value === "active" && oldValue === "delete") {
            console.log("Reactivating deleted client:", client?.id);
          }

          if (value === "preactivation" && originalStatus !== "preactivation") {
            modal(adminClientCannotPreactivate);
          } else if (value === "resetting" && originalStatus !== "resetting") {
            modal(adminClientCannotReset);
          }
        }, 0);

        return; // Exit early since we've handled the status change
      } else if (
        name === "client.accountInfo.settings.pushnotifications" ||
        name === "client.accountInfo.settings.emailnotifications" ||
        name === "client.accountInfo.settings.marketingnotifications" ||
        name === "client.accountInfo.settings.holidaymode"
      ) {
        let splitString = name.split(".");
        let settingType = splitString[splitString.length - 1];
        setClient((prevClient) => ({
          ...prevClient,
          accountInfo: {
            ...prevClient?.accountInfo,
            settings: {
              ...prevClient?.accountInfo.settings,
              [settingType]: value,
            },
          },
        }));
      } else if (name != "client.accountInfo.terms") {
        if (name.split(".").length == 1) {
          // Handle top-level state updates
          if (name === "search") {
            setSearch(value);
          } else if (name === "sort") {
            setSort(value);
          }
        } else if (name.split(".").length == 2) {
          const [objKey, propKey] = name.split(".");
          if (objKey === "client") {
            setClient((prevClient) => ({
              ...prevClient,
              [propKey]: value,
            }));
          } else if (objKey === "pagination") {
            setPagination((prevPagination) => ({
              ...prevPagination,
              [propKey]: value,
            }));
          }
        } else if (name.split(".").length == 3) {
          // Handle deeply nested object updates
          const [objKey, nestedKey, propKey] = name.split(".");
          if (objKey === "client" && nestedKey === "accountInfo") {
            setClient((prevClient) => ({
              ...prevClient,
              accountInfo: {
                ...prevClient?.accountInfo,
                [propKey]: value,
              },
            }));
          }
        } else {
        }
      }
    },
    [client?.status, client?.id, originalStatus]
  );

  const deleteClientAvatar = useCallback((event) => {
    if (event) {
      event.preventDefault();
    }

    setClient((prevClient) => ({
      ...prevClient,
      accountInfo: {
        ...prevClient?.accountInfo,
        avatar: "",
      },
    }));
  }, []);

  const sortJobs = useCallback(
    (event, theSort) => {
      if (event) {
        event.preventDefault();
      }

      var tmpSort;

      if (theSort == "status") {
        if (sort === '{"jobSpec.status":1}') {
          tmpSort = '{"jobSpec.status":-1}';
        } else {
          tmpSort = '{"jobSpec.status":1}';
        }
      } else if (theSort == "jobdate") {
        if (
          sort ===
          '{"jobSpec.dateAndTime.standardDate":1,"jobSpec.standardDate":1}'
        ) {
          tmpSort =
            '{"jobSpec.dateAndTime.standardDate":-1,"jobSpec.standardDate":-1}';
        } else {
          tmpSort =
            '{"jobSpec.dateAndTime.standardDate":1,"jobSpec.standardDate":1}';
        }
      } else if (theSort == "jobtype") {
        if (sort === '{"jobSpec.serviceType":1,"jobSpec.serviceType":1}') {
          tmpSort = '{"jobSpec.serviceType":-1,"jobSpec.serviceType":-1}';
        } else {
          tmpSort = '{"jobSpec.serviceType":1,"jobSpec.serviceType":1}';
        }
      } else if (theSort == "location") {
        if (sort === '{"originAddress.formattedAddress":1}') {
          tmpSort = '{"originAddress.formattedAddress":-1}';
        } else {
          tmpSort = '{"originAddress.formattedAddress":1}';
        }
      } else if (theSort == "created") {
        if (sort === '{"creationDate":1}') {
          tmpSort = '{"creationDate":-1}';
        } else {
          tmpSort = '{"creationDate":1}';
        }
      } else if (theSort == "quotes") {
        if (sort === '{"quotes":1}') {
          tmpSort = '{"quotes":-1}';
        } else {
          tmpSort = '{"quotes":1}';
        }
      }

      setSearch("");
      setSort(tmpSort);
      setPagination({
        page: 1,
        total: 1,
      });
    },
    [sort]
  );

  const filterJob = useCallback((event) => {
    if (event) {
      event.preventDefault();
    }

    setSearch("");
    setPagination({
      page: 1,
      total: 1,
    });
  }, []);

  const nextPage = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }

      if (pagination.page < pagination.total) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          page: prevPagination.page + 1,
        }));
      }
    },
    [pagination.page, pagination.total]
  );

  const prevPage = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }

      if (pagination.page > 1) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          page: prevPagination.page - 1,
        }));
      }
    },
    [pagination.page]
  );

  // Effect to handle filter changes
  useEffect(() => {
    if (filter !== "all") {
      filterJob();
    }
  }, [filter, filterJob]);

  // Effect to handle sort and pagination changes that trigger getClient
  useEffect(() => {
    if (sort) {
      getClient();
    }
  }, [sort, getClient]);

  useEffect(() => {
    if (pagination.page !== 1) {
      getClient();
    }
  }, [pagination.page, getClient]);

  // Initial mount effect
  useEffect(() => {
    getClient();
  }, [getClient]);

  const toggleDrawer =
    (anchor, open, view = null, client = null) =>
    (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (client) {
          setSelectedClient(client);
        } else {
          setSelectedClient(null);
        }
      }
    };

  const list = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <ClientEdit
        view={currentView}
        client={selectedClient}
        onClose={toggleDrawer(anchor, false)}
        userDetails={userDetails}
      />
    </Box>
  );

  const handleSaveResponse = useCallback(
    (resStatus, responseString, resJson) => {
      closeSpinner();

      switch (resStatus) {
        case 401:
          modal(sessionExpired);
          toScreen(false, navigate, "/logout");
          break;
        case 400:
          modal(responseString);
          break;
        case 200:
          modal("Changes successfully saved", false, () => {
            toScreen(false, navigate, "/clients");
          });
          break;
        default:
          modal("An error occurred. Please try again.");
      }
    },
    [navigate]
  );

  // Save client data
  const handleSave = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }
      setShowSaveConfirm(true);
    },
    []
  );

  const handleConfirmSave = useCallback(() => {
    setShowSaveConfirm(false);
    showSpinner();

    const userData = {
      accountInfo: {
        username: userDetails?.accountInfo?.username,
        email: userDetails?.accountInfo?.email,
      },
      user: {
        _id: client._id,
        short_id: client.short_id,
        notes: client?.notes,
        userType: client?.userType,
      },
    };

    setUser(userData, handleSaveResponse, userDetails?.jwttoken);
  }, [userDetails, client, handleSaveResponse]);

  const handleCancelSave = useCallback(() => {
    setShowSaveConfirm(false);
  }, []);
  return (
    <>
      <TopNav title="Client Details" />
      <div className="global-body">
        {/* Hide Content */}
        <div className="global-body-container">
          {client ? (
            <>
              <button
                className="btn-outline-light icon-with-btn"
                onClick={() => navigate("/clients")}
              >
                <BackArrowIcon />
                Back to Clients
              </button>
              {/* Client Details Card */}
              <div className="card client-card mt-16 mb-24">
                <div className="d-flex align-items-center g-24">
                  <div>
                    <h3 className="fw-semibold mb-4">
                      {client?.accountInfo?.username}
                    </h3>
                    <div className="client-details">
                      <span className="text-sm text-gray-500">
                        {client?.accountInfo?.email}
                      </span>
                      <span className="text-sm text-gray-400">•</span>
                      <span className="text-sm text-gray-500 text-capitalize">
                        {client?.short_id?.toUpperCase()}
                      </span>
                      <span className="text-sm text-gray-400">•</span>
                      <span className="badge badge-success">
                        {client?.status?.charAt(0).toUpperCase() +
                          client?.status?.slice(1)}
                      </span>

                      {["right"].map((anchor) => (
                        <React.Fragment key={anchor}>
                          <button
                            className="custom-btn"
                            onClick={toggleDrawer(
                              anchor,
                              true,
                              "editprofile",
                              client
                            )}
                          >
                            <EditIcon />
                          </button>
                          <Drawer
                            anchor={anchor}
                            open={state[anchor]}
                            onClose={toggleDrawer(anchor, false)}
                            ModalProps={{
                              BackdropProps: {
                                style: {
                                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                                },
                              },
                            }}
                            sx={{
                              boxShadow: "none",
                              "& .MuiDrawer-paper": { boxShadow: "none" },
                            }}
                          >
                            {list(anchor)}
                          </Drawer>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-purple icon-with-btn"
                    onClick={() =>
                      (window.location.href =
                        "https://dashboard.stripe.com/payments/" +
                        client?.short_id)
                    }
                  >
                    <ViewInStripe />
                    View in Stripe
                  </button>
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        "/message/" + client?.short_id,
                        false,
                        {
                          receiverId: client?._id,
                          receiverShortId: client?.short_id,
                          receiverType: client?.userType,
                          userShortId1: "admin",
                          userShortId2: client?.short_id,
                          username2: client?.accountInfo?.username,
                          selectedPage:
                            window.history.state.usr?.selectedPage ?? 1,
                          selectedFilter:
                            window.history.state.usr?.selectedFilter ??
                            defaultMessagesFilter,
                          previousPath:
                            window.history.state.usr?.previousPath ??
                            window.location.pathname,
                        }
                      )
                    }
                  >
                    <MessageIcon />
                    Message {client?.accountInfo?.firstname}
                  </button>
                </div>
              </div>

              <div className="card mb-24 py-16">
                <ul className="d-flex align-items-center justify-content-between">
                  <li>
                    <span className="text-sm text-gray-500 d-block">
                      Total Spent
                    </span>
                    <h5 className="fw-semibold mb-0 text-lg">
                      £{client?.totalSpent || 0}
                    </h5>
                  </li>
                  <li>
                    <span className="text-sm text-gray-500 d-block">
                      Jobs Posted
                    </span>
                    <h5 className="fw-semibold mb-0 text-lg">
                      {client?.totalJobs || 0}
                    </h5>
                  </li>
                  <li>
                    <span className="text-sm text-gray-500 d-block">
                      Active Jobs
                    </span>
                    <h5 className="fw-semibold mb-0 text-lg">
                      {client?.activeJobs || 0}
                    </h5>
                  </li>
                  <li>
                    <span className="text-sm text-gray-500 d-block">
                      Booked
                    </span>
                    <h5 className="fw-semibold mb-0 text-lg">
                      {client?.booked || 0}
                    </h5>
                  </li>
                  <li>
                    <span className="text-sm text-gray-500 d-block">
                      Cancelled
                    </span>
                    <h5 className="fw-semibold mb-0 text-lg">
                      {client?.cancelled || 0}
                    </h5>
                  </li>
                </ul>
              </div>

              <section className="tabing-section">
                {/* Left Side Content */}
                <div className="tab-content">
                  <div className="modal-card">
                    <div className="custom-tabs m-0">
                      <div
                        className={`tab-item ${
                          activeTab === "profile" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("profile")}
                      >
                        Profile
                      </div>
                      <div
                        className={`tab-item ${
                          activeTab === "notifications" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("notifications")}
                      >
                        Notifications
                      </div>
                    </div>
                    <div className="p-24">
                      {/* Profile Info */}
                      {activeTab === "profile" && (
                        <>
                          <div className="card-header">
                            <h5>Profile Information</h5>

                            {["right"].map((anchor) => (
                              <React.Fragment key={anchor}>
                                <button
                                  className="btn-outline-light icon-with-btn"
                                  onClick={toggleDrawer(
                                    anchor,
                                    true,
                                    "editprofile",
                                    client
                                  )}
                                >
                                  <EditIcon />
                                  Edit
                                </button>
                                <Drawer
                                  anchor={anchor}
                                  open={state[anchor]}
                                  onClose={toggleDrawer(anchor, false)}
                                  ModalProps={{
                                    BackdropProps: {
                                      style: {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                      },
                                    },
                                  }}
                                  sx={{
                                    boxShadow: "none",
                                    "& .MuiDrawer-paper": { boxShadow: "none" },
                                  }}
                                >
                                  {list(anchor)}
                                </Drawer>
                              </React.Fragment>
                            ))}
                          </div>
                          <div>
                            <ul className="profile-info">
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  First name
                                </span>
                                <p>{client?.accountInfo?.firstname}</p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Surname
                                </span>
                                <p>{client?.accountInfo?.surname}</p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Username
                                </span>
                                <p>{client?.accountInfo?.username}</p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Email
                                </span>
                                <p className="word-wrap">{client?.accountInfo?.email}</p>
                              </li>
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Telephone
                                </span>
                                <p>{client?.accountInfo?.telephone}</p>
                              </li>{" "}
                              <li className="profile-info-item">
                                <span className="profile-info-title">
                                  Terms agreed
                                </span>
                                <p>
                                  {client?.accountInfo?.terms === true
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                      {/* Notification List */}
                      {activeTab === "notifications" && (
                        <>
                          <div className="card-header">
                            <h5>Notifications Settings</h5>
                            {["right"].map((anchor) => (
                              <React.Fragment key={anchor}>
                                <button
                                  className="btn-outline-light icon-with-btn"
                                  onClick={toggleDrawer(
                                    anchor,
                                    true,
                                    "editnotification",
                                    client
                                  )}
                                >
                                  <EditIcon />
                                  Edit
                                </button>
                                <Drawer
                                  anchor={anchor}
                                  open={state[anchor]}
                                  onClose={toggleDrawer(anchor, false)}
                                  ModalProps={{
                                    BackdropProps: {
                                      style: {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                      },
                                    },
                                  }}
                                  sx={{
                                    boxShadow: "none",
                                    "& .MuiDrawer-paper": { boxShadow: "none" },
                                  }}
                                >
                                  {list(anchor)}
                                </Drawer>
                              </React.Fragment>
                            ))}
                          </div>
                          <div>
                            <ul className="notification-list">
                              <li className="notification-list-item">
                                <div>
                                  <div className="d-flex align-items-center g-8">
                                    <BellIcon />
                                    <span className="text-sm">
                                      Push notifications
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-500 mt-2">
                                    User receives job alerts and updates on
                                    their devices
                                  </p>
                                </div>
                                <label htmlFor="switch" className="switch">
                                  <input
                                    id="switch"
                                    type="checkbox"
                                    disabled
                                    onChange={handleInputChange}
                                    checked={
                                      client?.accountInfo?.settings
                                        .pushnotifications === true
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </li>
                              <li className="notification-list-item">
                                <div>
                                  <div className="d-flex align-items-center g-8">
                                    <EmailIcon />
                                    <span className="text-sm">
                                      Email notifications
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-500 mt-2">
                                    User receives important account updates via
                                    email
                                  </p>
                                </div>
                                <label
                                  htmlFor="emailnotifications1"
                                  className="switch"
                                >
                                  <input
                                    id="emailnotifications1"
                                    type="checkbox"
                                    disabled
                                    onChange={handleInputChange}
                                    checked={
                                      client?.accountInfo?.settings
                                        .emailnotifications === true
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </li>
                              <li className="notification-list-item">
                                <div>
                                  <div className="d-flex align-items-center g-8">
                                    <DiscountIcon />
                                    <span className="text-sm">
                                      Marketing notifications
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-500 mt-2">
                                    User receives special offers and promotional
                                    content
                                  </p>
                                </div>
                                <label
                                  htmlFor="marketingnotifications1"
                                  className="switch"
                                >
                                  <input
                                    id="marketingnotifications1"
                                    type="checkbox"
                                    disabled
                                    onChange={handleInputChange}
                                    checked={
                                      client?.accountInfo?.settings
                                        .marketingnotifications === true
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </li>
                              <li className="notification-list-item">
                                <div>
                                  <div className="d-flex align-items-center g-8">
                                    <BellSlashIcon />
                                    <span className="text-sm">
                                      Holiday mode
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-500 mt-2">
                                    All notifications are temporarily paused for
                                    the user
                                  </p>
                                </div>
                                <label
                                  htmlFor="holidaymode1"
                                  className="switch"
                                >
                                  <input
                                    id="holidaymode1"
                                    type="checkbox"
                                    disabled
                                    onChange={handleInputChange}
                                    checked={
                                      client?.accountInfo?.settings.holidaymode
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <AuditNotes
                  ref={ref}
                  notes={client?.notes}
                  updateNotes={updateNotes}
                />
              </section>
              <br />
              <div className="table-wrap">
                <div className="title-wrap border-bottom-0">
                  <h3 className="font-semibold tracking-tight text-xl ">
                    Jobs posted
                  </h3>
                </div>
              </div>
              {_.size(client?.jobs) > 0 ? (
                <div className="table-responsive">
                  <table className="table clientTable">
                    <thead>
                      <tr>
                        <th>
                          <button
                            // className={
                            //   this.state.sort == '{"jobSpec.status":-1}'
                            //     ? "c-list-filter__button c-list-filter__button--icon-up"
                            //     : this.state.sort == '{"jobSpec.status":1}'
                            //       ? "c-list-filter__button c-list-filter__button--icon-down"
                            //       : "c-list-filter__button c-list-filter__button--faded"
                            // }
                            // onClick={(e) => this.sortJobs(e, "status")}
                            className="p-0 cursor-default"
                          >
                            Status
                          </button>
                        </th>
                        <th>
                          <button
                            className="p-0 cursor-default"
                            // className={
                            //   this.state.sort == '{"quotes":-1}'
                            //     ? "c-list-filter__button c-list-filter__button--icon-up"
                            //     : this.state.sort == '{"quotes":1}'
                            //       ? "c-list-filter__button c-list-filter__button--icon-down"
                            //       : "c-list-filter__button c-list-filter__button--faded"
                            // }
                            // onClick={(e) => this.sortJobs(e, "quotes")}
                          >
                            Quotes
                          </button>
                        </th>
                        <th>
                          <button
                            className="p-0 cursor-default"
                            // className={
                            //   this.state.sort ==
                            //     '{"jobSpec.dateAndTime.standardDate":1,"jobSpec.standardDate":1}'
                            //     ? "c-list-filter__button c-list-filter__button--icon-up"
                            //     : this.state.sort ==
                            //       '{"jobSpec.dateAndTime.standardDate":-1,"jobSpec.standardDate":-1}'
                            //       ? "c-list-filter__button c-list-filter__button--icon-down"
                            //       : "c-list-filter__button c-list-filter__button--faded"
                            // }
                            // onClick={(e) => this.sortJobs(e, "jobdate")}
                          >
                            Job date
                          </button>
                        </th>
                        <th>
                          <button
                            // className={
                            //   this.state.sort ==
                            //     '{"jobSpec.serviceType":1,"jobSpec.serviceType":1}'
                            //     ? "c-list-filter__button c-list-filter__button--icon-up"
                            //     : this.state.sort ==
                            //       '{"jobSpec.serviceType":-1,"jobSpec.serviceType":-1}'
                            //       ? "c-list-filter__button c-list-filter__button--icon-down"
                            //       : "c-list-filter__button c-list-filter__button--faded"
                            // }
                            // onClick={(e) => this.sortJobs(e, "jobtype")}
                            className="p-0 cursor-default"
                          >
                            Job Type
                          </button>
                        </th>
                        <th>
                          <button
                            // className={
                            //   this.state.sort ==
                            //     '{"originAddress.formattedAddress":-1}'
                            //     ? "c-list-filter__button c-list-filter__button--icon-up"
                            //     : this.state.sort ==
                            //       '{"originAddress.formattedAddress":1}'
                            //       ? "c-list-filter__button c-list-filter__button--icon-down"
                            //       : "c-list-filter__button c-list-filter__button--faded"
                            // }
                            // onClick={(e) => this.sortJobs(e, "location")}
                            className="p-0 cursor-default"
                          >
                            Location
                          </button>
                        </th>
                        <th>
                          <button
                            // className={
                            //   this.state.sort == '{"creationDate":-1}'
                            //     ? "c-list-filter__button c-list-filter__button--icon-up"
                            //     : this.state.sort == '{"creationDate":1}'
                            //       ? "c-list-filter__button c-list-filter__button--icon-down"
                            //       : "c-list-filter__button c-list-filter__button--faded"
                            // }
                            // onClick={(e) => this.sortJobs(e, "created")}
                            className="p-0 cursor-default"
                          >
                            Created
                          </button>
                        </th>
                        <th></th>
                        {/* <th>
                      <button
                        type="button"
                        className="c-btn c-btn--small me-0 disable-btn"
                      >
                        {" "}
                        View Details{" "}
                      </button>
                      </th> */}
                      </tr>
                    </thead>
                    <tbody>{Object.keys(client?.jobs)?.map(renderJobs)}</tbody>
                  </table>
                </div>
              ) : (
                <span className="text-danger">No jobs for this Client.</span>
              )}
              <Pagination
                pageSize={pageSize}
                totalPages={totalPages}
                page={page}
                setPage={setPage}
                inputValue={inputValue}
                setInputValue={setInputValue}
                setPageSize={setPageSize}
              />
            </>
          ) : (
            modal(
              "Client user details not found",
              "Something went wrong!",
              () => window.history.back()
            )
          )}
        </div>
      </div>

      <ConfirmDialog
        open={showSaveConfirm}
        title="Save Changes"
        message={adminSaveChangesConfirm}
        onConfirm={handleConfirmSave}
        onCancel={handleCancelSave}
        confirmText="Save"
        cancelText="Cancel"
        variant="info"
      />
    </>
  );
};

Client.contextTypes = {
  router: PropTypes.object,
};

Client.propTypes = {
  userDetails: PropTypes.object.isRequired,
  clientId: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(Client);
